import DefaultElementNodeType from '../DefaultElementNodeType';
import {TECHNOLOGY_COMMUNICATION_NETWORK} from '../../metamodel/Concept';

export default class CommunicationNetworkNodeType extends DefaultElementNodeType {
	static get typeName() {
		return TECHNOLOGY_COMMUNICATION_NETWORK;
	}
}
